import { Minus } from '@dreamstack/icons/src/icon-components/Minus'
import { Plus } from '@dreamstack/icons/src/icon-components/Plus'
import type { FunctionComponent } from 'react'
import React, { useState } from 'react'

export const BTLCalcAccordionBlock: FunctionComponent<
  React.PropsWithChildren<{
    title: string
  }>
> = (props) => {
  const [status, setStatus] = useState(true)

  return (
    <div>
      <div className="flex flex-row justify-start font-semibold">
        <div>
          {status && (
            <Minus
              className="cursor-pointer mr-px-12 w-px-32 h-px-32"
              onClick={() => setStatus(false)}
            />
          )}
          {!status && (
            <Plus
              className="cursor-pointer mr-px-12 w-px-32 h-px-32"
              onClick={() => setStatus(true)}
            />
          )}
        </div>
        <div className="text-[20px] font-semibold">{props.title}</div>
      </div>

      {status && <div className="pt-px-12">{props.children}</div>}
      <br />
    </div>
  )
}
